<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

*{
  margin: 0;
  padding: 0;
}
#app{
  width: 100%;
  height: 100%;
}
.pageSize {
  text-align: center;
  margin: 30px 0 60px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue